/**
 * SecondaryMenu component.
 */

import stickybits from 'stickybits';

class SecondaryMenu {
	/**
	 * Constructs the SecondaryMenu object and initialises DOM elements.
	 */
	constructor() {
		this.root = document.documentElement;
		this.secondaryHeader = document.querySelector( '.global-secondary-header' );
	}

	/**
	 * Initialises the SecondaryMenu by setting up sticky behaviour.
	 */
	init() {
		// Early return if the secondary header is not found
		if ( ! this.secondaryHeader ) {
			return;
		}

		this.setupStickyBehaviour();
	}

	/**
	 * Sets up sticky behaviour for the secondary header with dynamic offset.
	 */
	setupStickyBehaviour() {
		const stickyArgs = {
			useStickyClasses: true,
		};

		stickybits( '.global-secondary-header', stickyArgs );
	}
}

export default SecondaryMenu;
